// MF-578 — A short "how to use" for the Board Builder, one click away. Plain words, in the order people need them.
import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../boardTheme'

const STEPS = [
  [
    'What a Board is',
    'A Board is a page of tiles. Each tile is one element of the Chart Library (a chart or a card). You choose the elements, place them on the grid, and publish: the Board then appears as a button in Analytics for the roles you choose.'
  ],
  [
    'Build it',
    'Open a Board, then add elements from the Library on the left. Drag a tile to move it and drag its corner to resize it. Click a tile to set it up on the right; click empty space to go back to the Board settings.'
  ],
  [
    'The panel on the right',
    'It has three groups. Content: title, description and how the title looks. Appearance: colours, chart type and legend. Data: which series show, the order, the value axis range, the options of the element, and what to do when there is no data. Each group can be closed to keep the panel short.'
  ],
  [
    'Options',
    'Some elements can be fixed to one test, year level or year. Leave a box empty for no filter: the tile then shows everything. A year needs four digits, for example 2026.'
  ],
  [
    'Colours',
    'The Board has a palette and an optional primary colour. Every tile uses them unless it picks its own. “Same as the Board” is almost always right.'
  ],
  [
    'Tiles with no data',
    'By default a tile with no data is hidden when someone opens the Board, and the rest move up. Choose “Show a message” on a tile to keep it.'
  ],
  [
    'Student dashboards',
    'In Board settings, “Staff choose a student first” makes staff pick a student before any number appears, instead of showing the school’s figures.'
  ],
  [
    'Draft and Publish',
    'Save keeps a draft that only builders see. Publish puts it in Analytics for the roles ticked under “Visible to”. Users see it after they sign in again.'
  ]
]

const BuilderGuide = () => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button size='small' onClick={() => setOpen(true)} sx={{ textTransform: 'none' }}>
        How to use
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth='sm' fullWidth>
        <DialogTitle>How to use the Board Builder</DialogTitle>
        <DialogContent dividers>
          {STEPS.map(([title, text]) => (
            <Box key={title} sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{title}</Typography>
              <Typography sx={{ fontSize: 13, color: SUMMARY_PALETTE.muted }}>{text}</Typography>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default BuilderGuide
